import { SWAN_STYLE_KEY_MAP } from '@vp/swan'
import { useSwanStyleKeys, useUserContextTracker, useLogger } from '@vp/ubik-context'
import { ContentfulContextProvider, DebugSection, ContentfulLink } from '@vp/mcs-react-tools'
import { TrackingProvider } from '../../hooks/trackingContext'
import { SeoZone } from './SeoZone'
import { FragmentLogger } from '@vp/ubik-logging'
import { type HomepageSeoProps } from '../../types/homepageSeo'
import type { TrackUsedContextProps } from '../../types/sharedTypes'

function trackUsedContext(props: TrackUsedContextProps) {
  const tracker = useUserContextTracker()
  if (props.experimentKey && props.variationKey) {
    tracker({
      type: 'experiment',
      name: props.experimentKey,
      variation: props.variationKey,
    })
  }
  if (props.decision) {
    tracker({
      type: 'treatment',
      name: props.decision,
    })
  }
  if (props.merchandisingCampaign) {
    tracker({
      type: 'campaign',
      name: props.merchandisingCampaign,
    })
  }
}

export const HomepageSeo = (props: HomepageSeoProps) => {
  const { seoZoneHeader, seoZoneTiles, seoZoneDescription } = props.pageData

  useSwanStyleKeys([SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.grid, SWAN_STYLE_KEY_MAP.utility])

  const logger = useLogger() as FragmentLogger

  logger.setContext({
    ...props,
    name: 'seo-fragment',
  })

  logger.info('Rendering SEO Fragment')

  trackUsedContext(props)

  const debugAvailability = {
    merchandisingCampaign: props.merchandisingCampaign,
    experimentKey: props.experimentKey,
    variationKey: props.variationKey,
    decision: props.decision,
  }
  const search = typeof window !== 'undefined' ? window.location.search : ''

  return (
    <ContentfulContextProvider space={props.contentfulMetadata.spaceId}>
      <ContentfulLink id={props.contentfulMetadata?.contentful_id} />
      <TrackingProvider canonicalUrl="https://www.vistaprint.com/">
        <DebugSection contentfulMetadata={props.contentfulMetadata} availability={debugAvailability} search={search} />
        <SeoZone header={seoZoneHeader} description={seoZoneDescription} tiles={seoZoneTiles} />
      </TrackingProvider>
    </ContentfulContextProvider>
  )
}
